<template>
  <nav v-if="parseInt(totalPages) > 1" class="v-pagination-container">
    <a :class="{ page: true, disabled: firstPageHit }" @click="previousPage">
      Previous
    </a>
    <a :class="{ page: true, disabled: lastPageHit }" @click="nextPage">
      Next
    </a>
  </nav>
</template>

<script>
export default {
  props: {
    'initCurrentPage': { type: Number, required: true },
    'initTotalPages': { type: Number, required: true },
  },
  data: function () {
    return {
      totalPages: this.initTotalPages,
      currentPage: this.initCurrentPage,
    };
  },
  computed: {
    firstPageHit() {
      return this.currentPage === 1;
    },
    lastPageHit() {
      return this.currentPage === this.totalPages;
    },
  },
  watch: {
    initTotalPages: function() {
      this.totalPages = this.initTotalPages;
      this.currentPage = this.initCurrentPage;
    },
  },
  methods: {
    nextPage: function() {
      if (this.lastPageHit) {
        return;
      }
      this.currentPage = this.currentPage + 1;
      this.$emit('pageChanged', this.currentPage);
    },
    previousPage: function() {
      if (this.firstPageHit) {
        return;
      }
      this.currentPage = this.currentPage - 1;
      this.$emit('pageChanged', this.currentPage);
    },
  },
};
</script>

